import { DecisionEnvironment } from "src/api/types";
import { PillToggle } from "src/base-components/PillToggle";
import { Skeleton } from "src/design-system/Skeleton";

export const EnvironmentPillPlaceholder = () => {
  return <Skeleton height="h-5" width="w-32" />;
};

// `test` has no DecisionEnvironment member: it is a powertools-only view, not
// somewhere a decision can be selected.
export type PillEnvironment = DecisionEnvironment | "test";

export const DEFAULT_PILL_ENVIRONMENTS: readonly PillEnvironment[] = [
  DecisionEnvironment.LIVE,
  DecisionEnvironment.SANDBOX,
];

const LABELS: Record<PillEnvironment, string> = {
  [DecisionEnvironment.LIVE]: "Live",
  [DecisionEnvironment.SANDBOX]: "Sandbox",
  test: "Test",
};

type EnvironmentPillProps = {
  environments?: readonly PillEnvironment[];
  value: DecisionEnvironment;
  onChange: (env: DecisionEnvironment) => void;
};

export const EnvironmentPill: React.FC<EnvironmentPillProps> = ({
  environments = DEFAULT_PILL_ENVIRONMENTS,
  value,
  onChange,
}) => {
  return (
    <PillToggle value={value} onChange={onChange}>
      {environments.map((environment) => (
        <PillToggle.Button key={environment} value={environment}>
          {LABELS[environment]}
        </PillToggle.Button>
      ))}
    </PillToggle>
  );
};
